export default {
  userColors: ['#46bddf', '#52d273', '#e84f64', '#e57255', '#e5c453'],
};
